<template>
    <slider
        v-if="data.images.length"
        :slides="data.images"
        ref="slider"
        class="b-gallery"
        :zoom="true"
        :showIndex="true"
        :options="{
            wrapAround: true,
            draggable: true,
        }"
    >
        <template #slide="image">
            <asset :asset="image" @loaded="refreshSlider()" />
        </template>
    </slider>
</template>

<script>
import Asset from 'objects/Asset'
import Slider from 'components/Slider'
import Icon from 'objects/Icon'

export default {
    name: 'BlockGallery',
    components: {
        Icon,
        Asset,
        Slider,
    },
    props: {
        data: false
    },
    methods: {
        refreshSlider() {
            this.$refs.slider.resize()
        }
    }
}
</script>

<style lang="scss">
.b-gallery {
    display: flex;
    flex-direction: column-reverse;

    .c-slider__side {
        justify-content: flex-end;
        margin: var(--grid-gutter-half) var(--grid-gutter) 0;
    }

    .c-slider__btn,
    .c-slide__count {
        --nav-bg: #{$color-light};
    }

}
</style>
